// extracted by mini-css-extract-plugin
export default {"BreakpointToMedium":"(max-width: 639px)","BreakpointFromLarge":"(min-width: 960px)","Mackerel":"#D2D6D9","heading":"G56c75b","line":"G45d59c"};